export default function refreshAt(hours, minutes, seconds) {
  const now = new Date();
  const then = new Date();

  /*eslint-disable */
  if (now.getHours() > hours ||
     (now.getHours() === hours && now.getMinutes() > minutes) ||
      now.getHours() === hours && now.getMinutes() === minutes && now.getSeconds() >= seconds) {
    then.setDate(now.getDate() + 1);
  }
  /*eslint-enable */

  then.setHours(hours);
  then.setMinutes(minutes);
  then.setSeconds(seconds);

  const timeout = (then.getTime() - now.getTime());

  console.log(`Will at ${hours}:${minutes}:${seconds} which is in ${timeout} ms`);

  setTimeout(() => window.location.reload(true), timeout);
}
